import * as React from "react"
import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image"

// COMPONENTS
import Layout from "../components/layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookSquare, faGithub, faInstagramSquare, faLinkedin, faTwitter } from "@fortawesome/free-brands-svg-icons";
import Seo from "../components/Seo";

const TeamPage = ({ data }) => {
  const teamPageData = data.allMarkdownRemark.edges;

  return (
    <Layout>
      <Seo title="Team - N.Johnstone&Co " />
      <div className="container">
        <div className="team-page">
          <div className="team-list">
            {teamPageData.map(x => {
              const member = x.node.frontmatter;
              const memberImage = getImage(x.node.frontmatter.photo);
              return (
                <div key={x.node.id} className="team-member flip-card">
                  <div className="flip-card-inner">
                    <div className="flip-card-front">
                      <h2>{member.first_name} {member.last_name}</h2>
                      <GatsbyImage
                        image={memberImage}
                        alt={member.first_name}
                        crossOrigin="anonymous"
                      />
                    </div>
                    <div className="flip-card-back">
                      <h2>{member.first_name} {member.last_name}</h2>
                      <p className="supporting-copy">{member.description}</p>
                      <div className="member-network">
                        <div>
                          {member?.facebook_url && <a href={member?.facebook_url}><FontAwesomeIcon role="link" icon={faFacebookSquare} size="2x" /></a>}
                          {member?.instagram_url && <a href={member?.instagram_url} ><FontAwesomeIcon role="link" icon={faInstagramSquare} size="2x" /></a>}
                          {member?.linkedin_url && <a href={member?.linkedin_url}><FontAwesomeIcon role="link" icon={faLinkedin} size="2x" /></a>}
                          {member?.github_url && <a href={member?.github_url}><FontAwesomeIcon role="link" icon={faGithub} size="2x" /></a>}
                          {member?.twitter_url && <a href={member?.twitter_url}><FontAwesomeIcon role="link" icon={faTwitter} size="2x" /></a>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const teamPageQuery = graphql`
query TeamPageQuery {
  allMarkdownRemark(
    sort: {fields: frontmatter___first_name}
    filter: {frontmatter: {first_name: {ne: null}}}
  ) {
    edges {
      node {
        id
        frontmatter {
          last_name
          first_name
          description
          github_url
          linkedin_url
          photo {
            id
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  }
}
`

export default TeamPage;